export const COLORS = {
    darkdarkGray: "#0A0A0A",
    darkGray: "#0D0D0D",
    white: "#FFF",
    creamWhite: "#FFFDD0",
    gray: "#2F2F2F",
    apronBrown: "#B5734C",
    apronBrownDark: "#8F4E2B",
    textPrimary: "#FFF",
    textSecondary: "#8f8f8f",
    inactive: "#88898B"
}